import React from "react";
import List from "../Hotels/List";

const HotelArchives = () => {
  return (
    <>
      <List archives={true} />
    </>
  );
};

export default HotelArchives;
